import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M21 3H3.01L3 21h18V3zm-3 11h-4v4h-4v-4H6v-4h4V6h4v4h4v4z"
}), 'LocalHospitalSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/LocalHospitalSharp.js
// module id = 4589
// module chunks = 2